module.exports = __webpack_public_path__ + "img/breakout-room.e2f56c83.svg";